module.exports = __webpack_public_path__ + "img/pay-icon.7ab1c4e7.svg";